import React, { useState, useEffect} from "react";
import {
  DonationButtonsMobile,
  DonationButtonsNotMobile,
} from "src/components/Button";
import classNames from "classnames";

export const Homepage = () => {
  const [isMonthly, setIsMonthly] = useState(2);
  const [donationAmt, setDonationAmt] = useState(10);
  const [customAmt, setCustom] = useState("");
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [utm, setUtm] = useState("");

  useEffect(() => {
    function handleResize() {
      setViewportWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const requestParentURL= () => {
    let message = {
      action: "getParentURL",
    };
    window.parent.postMessage(
      message,
      "https://www.thecity.nyc"
    );
  };
  
  const handleMessage = (event:any) => {

    if (event.origin !== "https://www.thecity.nyc") {
      console.log("event.origin!==https://www.thecity.nyc");
      return;
    }
  
    const data = event.data;

    if (data.action === "sendingBackParentURL") {
      let article_slug = data.parentURL
      setUtm(article_slug)
    }
};

    requestParentURL();
    window.addEventListener("message", handleMessage);

  let donationFormText =
    viewportWidth < 400
      ? 
      "Did you know that THE CITY is a charitable 501(c)(3) nonprofit organization? We rely on donations from readers like you to sustain our local reporting and keep it free for all New Yorkers."
      : 
      "Did you know that THE CITY is a charitable 501(c)(3) nonprofit organization? We rely on donations from readers like you to sustain our local reporting and keep it free for all New Yorkers.";

  const monthlyDonationAmts = [5, 10, 15, 20];

  const getOneTimeDonationAmt = (amt: number) => {
    return { 5: 25, 10: 50, 15: 150, 20: 250 }[amt];
  };

  const getAnnualDonationAmt = (amt: number) => {
    return { 5: 60, 10: 120, 15: 250, 20: 500 }[amt];
  };

  const generateDonationURL = () => {
    console.log('generateDonationURL function fired');
    (window as any).gtag('event', 'donation_click_continue', {
      'article_slug': utm,
      'which_donation_box':'bottom_donation_box'
    });

    if (customAmt) {
      return window.open(`https://donorbox.org/donatenyc/?amount=${(customAmt)}&default_interval=${
        (isMonthly===1 ? "a" : isMonthly===2 ? "m" : "o")
      }&utm_source=${(utm)}&utm_campaign=bottom-box`, '_blank');
    }
    return window.open(`https://donorbox.org/donatenyc/?amount=${
      isMonthly===1 ? getAnnualDonationAmt(donationAmt): isMonthly===2 ?(donationAmt) : getOneTimeDonationAmt(donationAmt)
    }&default_interval=${(isMonthly===1 ? "a" : isMonthly===2 ? "m" : "o")}&utm_source=${(utm)}&utm_campaign=bottom-box`, '_blank');
  };

  const styles = {
    fontFamily: "Sharp Grotesk, Helvetica, sans-serif",
    fontSize: "14px",
    color:"black"
  };

  const customAmtStyles = {
    marginRight: "45px",
    marginLeft: "45px",
  };

  const continueButton = {
    marginTop: "20px",
  };

  return (
    <div
      style={styles}
      className="is-flex is-flex-direction-column has-text-centered is-align-content-center pb-6"
    >
      {/*  is-size-2 too big for mobile*/}
      <h1 className="pt-6 mx-3" style={{color:"black", font:"Sharp Grotesk, Helvetica, sans-serif", fontWeight:"800", fontSize:"4.5em", lineHeight:"70px"}}>
        {viewportWidth < 400 ? (
          <>
            Thanks for reading. <br />
            While you're here...
          </>
        ) : (
          "Thanks for reading. While you're here..."
        )}
      </h1>
      <h2 className="mt-4 pt-0 mx-6 mb-1" style={{color:"black", fontSize:"1.3em"}}>
        {donationFormText}
      </h2>
      <br/>

      <div className="mx-4">
        <p style={{font:"Sharp Grotesk, Helvetica, sans-serif", fontSize:"1.3em", fontWeight:"700"}}>
        Give today to join the community that powers the local news New York City deserves.
        </p>
      </div>

      <div className="control pb-3 mt-2" style={{color:"black"}}>
        <br className="is-hidden-tablet" />
        <label className="radio mx-2">
          <input
            className="mr-1"
            type="radio"
            name="answer"
            checked={isMonthly===1}
            onChange={() => {
              setIsMonthly(1);
            }}
          />
          Annual Donation
        </label>
        <label className="radio mx-2">
          <input
            className="mr-1"
            type="radio"
            name="answer"
            checked={isMonthly===2}
            onChange={() => {
              setIsMonthly(2);
            }}
          />
          Monthly Donation
        </label>

        <label className="radio mx-2">
          <input
            className="mr-1"
            type="radio"
            name="answer"
            checked={isMonthly===3}
            onChange={() => {
              setIsMonthly(3);
            }}
          />
          One-Time Donation
        </label>
        
      </div>
      {viewportWidth < 400 ? (
        <DonationButtonsMobile
          monthlyDonationAmts={monthlyDonationAmts}
          donationAmt={donationAmt}
          setDonationAmt={setDonationAmt}
          isMonthly={isMonthly}
          getOneTimeDonationAmt={getOneTimeDonationAmt}
          getAnnualDonationAmt={getAnnualDonationAmt}
        />
      ) : (
        <DonationButtonsNotMobile
          monthlyDonationAmts={monthlyDonationAmts}
          donationAmt={donationAmt}
          setDonationAmt={setDonationAmt}
          isMonthly={isMonthly}
          getOneTimeDonationAmt={getOneTimeDonationAmt}
          getAnnualDonationAmt={getAnnualDonationAmt}
        />
      )}

      <div
        className={classNames(
          "is-align-content-center is-justify-content-center",
          viewportWidth < 400 ? "" : "field is-grouped"
        )}
        style={{ marginTop: "2.25em" }}
      >
        <p
          className="control has-icons-left"
          style={viewportWidth < 400 ? customAmtStyles : {}}
        >
          <span className="icon is-left is-small">$</span>
          <input
            className="input is-info"
            type="number"
            placeholder="Custom Amount"
            min="0"
            value={customAmt}
            onChange={(e) => {
              setCustom(e.target.value);
            }}
            onClick={() => {
              setDonationAmt(0);
            }}
          ></input>
        </p>
        <p
          className="control has-text-weight-bold"
          style={viewportWidth < 400 ? continueButton : {}}
        >
          <button
            onClick={generateDonationURL}
            className="button is-rounded is-outlined has-background-white"
            style={{color:"black"}}
          >
            continue
          </button>
        </p>
      </div>
    </div>
  );
};
